import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";
import { colors } from "../../../utils/colors";
import { HeroTitle } from "../../atoms/HeroTitle";

export const Outer = styled.div`
    background-color: ${colors.brandMid};
`;

export const Inner = styled.div`
    padding: 45px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    ${breakpoints.large} {
        padding: 100px 0;
        height: 250px;
    }
`;

export const Title = styled(HeroTitle)`
    text-align: center;
    font-weight: 800;
`;
